import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
 
  SAVE_ATTRIBUTE_FORM_ERROR,
  SAVE_ATTRIBUTE_FORM_REQUEST,
  SAVE_ATTRIBUTE_FORM_SUCCESS,
  FETCH_ATTRIBUTE_FORM_ERROR,
  FETCH_ATTRIBUTE_FORM_REQUEST,
  FETCH_ATTRIBUTE_FORM_SUCCESS,
  UPDATE_ATTRIBUTE_FORM_REQUEST,
  UPDATE_ATTRIBUTE_FORM_ERROR,
  UPDATE_ATTRIBUTE_FORM_SUCCESS
} from 'actionTypes'
import moment from 'moment'


export const saveAttributeRequest = () => ({
    type: SAVE_ATTRIBUTE_FORM_REQUEST
})

export const saveAttributeRequestError = (error) => ({
    type: SAVE_ATTRIBUTE_FORM_ERROR,
    payload:error
})

export const saveAttributeRequestSuccess = (data) => ({
    type: SAVE_ATTRIBUTE_FORM_SUCCESS,
    payload:data 
})

export const updateAttributeRequest = () => ({
  type: UPDATE_ATTRIBUTE_FORM_REQUEST
})

export const updateAttributeRequestError = (error) => ({
  type: UPDATE_ATTRIBUTE_FORM_ERROR,
  payload:error
})

export const updateAttributeRequestSuccess = (data) => ({
  type: UPDATE_ATTRIBUTE_FORM_SUCCESS,
  payload:data 
})


export const fetchAttributeRequest = () => ({
  type: FETCH_ATTRIBUTE_FORM_REQUEST
})

export const fetchAttributeRequestError = (error) => ({
  type: FETCH_ATTRIBUTE_FORM_ERROR,
  payload:error
})

export const fetchAttributeRequestSuccess = (data) => ({
  type: FETCH_ATTRIBUTE_FORM_SUCCESS,
  payload:data 
})

export const saveAttributeReset = () => ({
  type: "SAVE_RESET"
})

export const resetAllDispatcher = () => ({
  type: "RESET_ALL"
})

export const resetAll = () => (dispatch) => {
  dispatch(resetAllDispatcher())
}


export const resetSave = () => (dispatch) => {
  dispatch(saveAttributeReset())
}
export const fetchAttributes = (token, query, callback) => (dispatch) => {
  
  if(!query.dtStart) {
    query.dtStart = moment().format('YYYY-MM-DD')
    query.dtEnd = moment().format('YYYY-MM-DD')
    query.onlyStatus = true
  }
  else {
    query.onlyStatus = false  
  }
  dispatch(fetchAttributeRequest())
  return new Api(token, dispatch)
  .get(API_URL.FETCH_ATTRIBUTE_PICTOGRAMS, query)
  .then(dispatch(showSpinner()))
  .then((response) => {
    if(callback) {
      callback()
    }

    
    dispatch(fetchAttributeRequestSuccess(response.data))
    dispatch(hideSpinner())

    return response
  })
  .catch((error) => {
    dispatch(fetchAttributeRequestError(error))
    dispatch(hideSpinner())
    return error
  })

}   

export const saveAttribute = (token, args, callBack) => (dispatch) => {
  dispatch(saveAttributeRequest())

  return new Api(token, dispatch)
    .post(API_URL.SAVE_ATTRIBUTE_PICTOGRAMS, args)
    .then(dispatch(showSpinner()))
    .then((response) => {
      /* istanbul ignore else */
      if (callBack) {
        callBack()
      }
      
      if([200,201].includes(response.cdStatus)) {
        dispatch(saveAttributeRequestSuccess(response.data))
        dispatch(hideSpinner())
        
      }

      else {
        
        dispatch(saveAttributeRequestError(response))
        dispatch(hideSpinner())
      }
      return response
    })
    .catch((error) => {
      
      dispatch(saveAttributeRequestError(error))
      dispatch(hideSpinner())

      return error
    })
}


export const updateAttribute = (token, body, id) => (dispatch) => {

  dispatch(updateAttributeRequest())
  return new Api(token,dispatch)
  .post(`${API_URL.UPDATE_ATTRIBUTE_PICTOGRAMS}/${id}`, body)
  .then(dispatch(showSpinner()))
  .then((response) => {
    if([200,201].includes(response.cdStatus)) {
      dispatch(hideSpinner())
      dispatch(updateAttributeRequestSuccess(response.data))
    }

    else {
      dispatch(updateAttributeRequestError(response))
      dispatch(hideSpinner())
    }
    return response

  }).catch((error) => {
      
    dispatch(updateAttributeRequestError(error))
    dispatch(hideSpinner())

    return error
  })
}

export const deleteAttributes = (token,body, callBack) => (dispatch) => new Api(token, dispatch)
    .deleteWithBody(API_URL.DELETE_ATTRIBUTE_PICTOGRAMS, body)
    .then(dispatch(showSpinner()))
    .then((response) => {
     
      if([200,201].includes(response.cdStatus)) {
        dispatch(hideSpinner())
        callBack()
      }

      else {
        dispatch(hideSpinner())
      }
      return response
    })
    .catch((error) => {
      
      dispatch(hideSpinner())

      return error
    })


